import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Media {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const format = this.el.dataset.format
    if (format !== 'square' && format !== 'rect') return

    gsap.fromTo(this.el,
      { scale: 0.88 },
      {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: this.el,
          start: 'top bottom',
          end: 'center center',
          scrub: 1.5,
        }
      }
    )
  }
}
